import { render, staticRenderFns } from "./userPopover.vue?vue&type=template&id=65427597"
import script from "./userPopover.vue?vue&type=script&lang=js"
export * from "./userPopover.vue?vue&type=script&lang=js"
import style0 from "./userPopover.vue?vue&type=style&index=0&id=65427597&prod&lang=scss"
import style1 from "./userPopover.vue?vue&type=style&index=1&id=65427597&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports